import React from 'react';
import Controls from './controls/Controls';
import { useNavigate } from 'react-router-dom';

function MaintenancePage() {
    const navigate = useNavigate();
    return (
        <>

        <div style={{ textAlign: 'center', marginTop: '50px' }}>
            <h1>الموقع قيد الصيانة</h1>
            <p>يمكنك العودة في وقت لاحق .</p>
        </div>
        <div style={{width:'100%' ,display:'flex',justifyContent:'center', alignItem:'center'}}>
            <img  style={{width:'50%' ,height:'100%'}} alt='maintenance_image' src='image_center-1.png'/>
        </div>
        <div style={{width:'100%' ,display:'flex',justifyContent:'center', alignItem:'center'}}>
            <Controls.Button
            style={{marginTop:'2%'}}
                    type="submit"
                    onClick={(()=>{

                    navigate("/")
                    })}
                    text="رجوع"
                    variant="contained"
                    className="btn-submit"
                  ></Controls.Button>
        </div>
        </>
    );
}

export default MaintenancePage;
